"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _SttButton = _interopRequireDefault(require("./SttButton"));
var _icons = require("@stt-componentes/icons");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function SttClearFilterButton(props) {
  return /*#__PURE__*/_react["default"].createElement(_SttButton["default"], _extends({}, props, {
    type: props.type || "button",
    variant: props.variant || "outlined",
    color: props.color || "primary",
    onClick: props.onClick || null,
    startIcon: /*#__PURE__*/_react["default"].createElement(_icons.FilterAltOff, null),
    disabled: props.disabled,
    nomarginleft: props.nomarginleft || undefined
  }), props.children || 'Limpar');
}
var _default = SttClearFilterButton;
exports["default"] = _default;